<template>
    <div id="cg-footer">
        <div class="white-space">
            <img src="@assets/img/logo/white-badge.png" alt="">
        </div>
        <div class="sitemap flex flex-wrap">
            <div class="lg:hidden mb-5 text-center xl:hidden md:w-1/2 sm:w-full smicns">
                <h3 class="block" >Social Media</h3>
                <div class="block text-center" >
                    <img class="m-1" src="@assets/icons/scin.svg" alt="" width="60" height="60">
                    <img class="m-1" src="@assets/icons/scyt.svg" alt="" width="60" height="60">

                </div>
                <div class="block text-center" >
                    <img class="m-1" src="@assets/icons/scfb.svg" alt="" width="60">
                    <img class="m-1" style="border-radius:50%" src="@assets/icons/scpi.png" alt="" width="60" height="60">
                </div>
            </div>
            <div class="lg:hidden mb-5 text-center xl:hidden md:w-1/2 sm:w-full">
                <h3 class="block" >Auszeichnungen</h3>
                <img class="mx-auto" src="@assets/img/BestOf_E-Commerce_2018.png" alt="Beste vom E-Commerce 2018">
            </div>
            <div class="w-1/5 text-center md:w-1/3 sm:w-full">
                <h3 class="block" >couchgourmet</h3>
                <div class="block" ><a @click.prevent="goTo('shops')" href="/shops">Alle Händler</a></div>
                <div class="block" ><a @click.prevent="goTo('products')" href="/products">Alle Produkte</a></div>
                <div class="block" ><a @click.prevent="goTo('shopCategory', {category: 'cheese'})" href="/shops/category/veggies">Käse & mehr</a></div>
                <div class="block" ><a @click.prevent="goTo('shopCategory', {category: 'meat'})" href="/shops/category/meat">Fleisch & Wurst</a></div>
                <div class="block" ><a @click.prevent="goTo('shopCategory', {category: 'seafood'})" href="/shops/category/seafood">Fisch & Meeresfrüchte</a></div>
                <div class="block" ><a @click.prevent="goTo('shopCategory', {category: 'veggies'})" href="/shops/category/veggies">Obst & Gemüse</a></div>
            </div>
            <div class="w-1/5 text-center md:w-1/3 sm:w-full">
                <h3 class="block" >Service & Kontakt</h3>
                <div class="block" ><a href="/service/terms-and-conditions" @click.prevent="goTo('service.Agb')">AGBs</a></div>
                <div class="block" ><a href="/service/privacy" @click.prevent="goTo('service.Privacy')">Datenschutz</a></div>
                <div class="block" ><a href="/service/imprint" @click.prevent="goTo('service.Imprint')">Impressum</a></div>
                <div class="block" ><a href="/service/contact" @click.prevent="goTo('service.Contact')">Kontakt</a></div>
                <div class="block"  v-if="false" ><a href="/service/press" @click.prevent="goTo('service.Press')">Presse</a></div>
                <div class="block" ><a href="/service/delivery" @click.prevent="goTo('service.Delivery')">Versand</a></div>
            </div>
            <div class="w-1/5 text-center md:w-1/3 sm:w-full">
                <h3 class="block" >Unternehmen</h3>
                <div class="block"  ><a @click.prevent="goTo('service.Partner')" href="/service/partner">Für Händler</a></div>
                <div class="block"  v-if="false" ><a @click.prevent="goTo('service.AgbPartner')" href="/service/terms-and-conditions-partners">Händler AGBs</a></div>
                <div class="block"  v-if="false" ><a @click.prevent="goTo('service.About')" href="/service/about">Über couchgourmet</a></div>
                <div class="block" ><a @click.prevent="goTo('service.Payment')" href="/service/payment">Zahlungsarten</a></div>
            </div>
            <div class="w-1/5 md:hidden sm:hidden smicns">
                <h3 class="block" >Social Media</h3>
                <div class="block text-center" >
                    <img class="m-1" src="@assets/icons/scin.svg" alt="" width="60" height="60">
                    <img class="m-1" src="@assets/icons/scyt.svg" alt="" width="60" height="60">

                </div>
                <div class="block text-center" >
                        <img class="m-1" src="@assets/icons/scfb.svg" alt="" width="60" >
                        <img class="m-1" style="border-radius:50%" src="@assets/icons/scpi.png" alt="" width="60" height="60">
                </div>
            </div>
            <div class="w-1/5 text-center md:hidden sm:hidden" >
                <h3 class="block" >Auszeichnungen</h3>
                <img class="block mx-auto" src="@assets/img/BestOf_E-Commerce_2018.png" alt="Beste vom E-Commerce 2018">
            </div>
        </div>
        <div class="tags text-center flex flex-wrap">
            <div class="w-1/4 md:hidden sm:hidden" ></div>
            <div class="w-1/4 md:w-1/2 sm:w-full">
                <a href="https://couch-gourmet.de">
                    <h3>couch-gourmet.de</h3>
                    <div>Einkaufen bei couchgourmet in Deutschland</div>
                </a>
            </div>
            <div class="w-1/4 md:w-1/2 sm:w-full">
                <a href="https://couch-gourmet.ch">
                    <h3>couch-gourmet.ch</h3>
                    <div>Einkaufen bei couchgourmet in der Schweiz</div>
                </a>
            </div>
            <div class="w-1/4 md:hidden sm:hidden"></div>
        </div>
    </div>
</template>

<script>
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  export default {
    name: 'cgfooter',
    mixins: [helpers, formatting]
  }
</script>



// WEBPACK FOOTER //
// src/components/CgFooter.vue